import routes from './digital-account.routes';

export const digitalAccountModule = {
    routes
};
